import { MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBAlert, MDBBtn, MDBCard, MDBCardBody, MDBCardTitle, MDBCol, MDBContainer, MDBFooter, MDBIcon, MDBNav, MDBNavItem, MDBNavLink, MDBRow, MDBTabContent, MDBTable, MDBTabPane } from 'mdbreact';
import React from 'react';
// import ReactDom from 'react-dom';
// import { Link as RouterLink } from 'react-router-dom';
// import profile_pic from '../../Assets/blank-profile-picture.png';
// import { Upload, Modal, Button } from 'antd';
import upload_icon from '../../Assets/upload_document.svg'
import delete_icon from '../../Assets/delete_icon.svg';
import edit_icon from '../../Assets/edit_icon.svg';
import move_icon from '../../Assets/move-icon.svg';
import zoom_icon from '../../Assets/zoom-in_icon.svg';
// import error_icon from '../../Assets/error_icon.svg';
// import info_icon from '../../Assets/info_icon.svg'
import { Redirect } from 'react-router-dom';
import axios from '../../authAxios';
import BasicInfoCard from '../BasicInfoCard/BasicInfoCard';
import Drag from "../../Drag";
import DropTarget from "../../DropTarget";
import logo from "../../logo.png";
import { FilePicker } from 'react-file-picker'
import image_loader from "../../Assets/spinner.gif"
import './Organize.css'
import ImageEditorRc from 'react-cropper-image-editor';
import 'cropperjs/dist/cropper.css'
// import {MDBAlert } from 'mdbreact';


// const itemDropped = item => {
//     console.log(JSON.parse(item))
// }
// const brand_color = localStorage.getItem('brand_color')



export class AdditionalOrganizeApplication extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            brand_color: "",
            activeItem: '',
            previewVisible: false,
            previewImage: '',
            previewTitle: '',
            fileList: [],
            modal: false,
            toTrackApplication: false,
            origin: '',
            nationality: '',
            travelling_to_country: '',
            visa_type: '',
            entry_type: '',
            visa_duration: '',
            applicants: '',
            arrival_dt: '',
            departure_dt: '',
            documents_pool: [],
            doc_img: '',
            application_id: '',
            appDocData: [],
            applicantsArr: [],
            isDocDeleted: false,
            deleteDocMessage: 'Document deleted from pool successfully',
            dataObj: {},
            selectedFile: '',
            showDeleteModall: false,
            cardToDelete: '',
            dimensions: {

                "width": "90%",
                "height": "50%"
            },
            imageLoader: false,
            showImageZoomModal: false,
            showImageEditModal: false,
            croppedImageUrl: "",
            showMinimumModal: false,
            isError: false,
            errorMsg: '',
            isProceed: false,
            showMissingFieldModal: false,
            missingData: [],
            docIdentifier: "",
            docFileName: "",
            saveLoader: false,
            showRemoveDocumentModal: false,
            noApplicantFound: false,
            removeCard: {},
            showRemoveModal: false,
            expiry_date: false,
            expiryModal: false,
            passportExpiredApplicant: "",
            getDocData: true,
            uploadPercentage: 0,

        }


        this.handleUploadApplicantDoc = this.handleUploadApplicantDoc.bind(this);
        this.handleAddApplicant = this.handleAddApplicant.bind(this);
        this.handleAddDocument = this.handleAddDocument.bind(this);
        this.handleDeleteApplicantTab = this.handleDeleteApplicantTab.bind(this);
        this.deleteToggle = this.deleteToggle.bind(this);
        this.removeToggle = this.removeToggle.bind(this)
        this.zoomImgToggle = this.zoomImgToggle.bind(this);
        this.deleteLastApplicant = this.deleteLastApplicant.bind(this)
        this.missingFieldToggle = this.missingFieldToggle.bind(this);
        this.removelinkedApplicantsDocument = this.removelinkedApplicantsDocument.bind(this)
        this.removeDocumentCard = this.removeDocumentCard.bind(this)
        this.validPassportModal = this.validPassportModal.bind(this)


    }


    missingFieldToggle = () => {
        this.setState({ showMissingFieldModal: !this.state.showMissingFieldModal })
    }
    itemDropped = (item, doc_type) => {
        // console.log(JSON.parse(item))
        // console.log(doc_type)
        // console.log(this.state.activeItem)
        this.setState({
            isError: false,
            errorMsg: 'Please select '
        })
        var docObj = JSON.parse(item)
        var applicant_id = this.state.activeItem


        axios
            .post('/visa/linkApplicantsDocument', {
                "applicant_id": applicant_id,
                "doc_type": doc_type,
                "doc_ocr": docObj.ocr,
                "file_name": docObj.file_name
            },
                {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                })
            .then(res => {
                // console.log(res);
                this.getApplicantDocData(applicant_id)

            })
            .catch(err => {
                console.log(err);
            })


    }


    toggle = tab => e => {
        console.log(tab);
        if (this.state.activeItem !== tab) {
            this.setState({
                activeItem: tab
            });
            this.setState({
                imageLoader: true,
            })
            // console.log("in toggle .........." + tab)
            this.getApplicantDocData(tab)
        }
    };

    toggleModal = () => {
        this.setState({
            modal: !this.state.modal
        });
    }

    handleCancel = () => this.setState({ previewVisible: false });

    handlePreview = async file => {
        if (!file.url && !file.preview) {
            file.preview = await (file.originFileObj);
        }

        this.setState({
            previewImage: file.url || file.preview,
            previewVisible: true,
            previewTitle: file.name || file.url.substring(file.url.lastIndexOf('/') + 1),
        });
    };

    handleChange = ({ fileList }) => this.setState({ fileList })

    componentDidMount() {
        this.setState({ brand_color: localStorage.getItem("brand_color") })

        this.setState({
            dimensions: {
                width: document.getElementById('footerRow').offsetWidth,
                height: 0,
            },
        });

        setTimeout(() => {
            this.api_getApplicantsDetails()

        }, 1000)
    }
    api_getApplicantsDetails() {
        axios
            .post('/visa/getApplicationApplicantsDetails', {
                "application_id": localStorage.getItem('application_id')
            },
                {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                })
            .then(res => {
                // console.log("!!!", res);
                // console.log(">>>>>>>>>>> "+res.data.dataobj.applicants.length)
                if (res.data.dataobj.applicants.length == 0) {
                    this.setState({ noApplicantFound: true })
                }
                // this.setState({isOrganiseApplication: true}) 
                // localStorage.setItem('application_id',res.data.dataobj._id)     
                // console.log(res.data.dataobj.application.nationality)
                var { origin, nationality, travelling_to_country, visa_type, entry_type, visa_duration, applicants, arrival_dt, departure_dt } = this.state;

                origin = res.data.dataobj.application.origin
                nationality = res.data.dataobj.application.nationality
                travelling_to_country = res.data.dataobj.application.travelling_to_country
                visa_type = localStorage.getItem('visa_type')
                entry_type = localStorage.getItem('entry_type')
                visa_duration = res.data.dataobj.application.total_days
                applicants = localStorage.getItem('applicants')
                arrival_dt = res.data.dataobj.application.journey_start_date
                departure_dt = res.data.dataobj.application.journey_end_date

                localStorage.setItem('travelling_to_identity', res.data.dataobj.application.travelling_to_identity)
                this.setState({ origin, nationality, travelling_to_country, visa_type, entry_type, visa_duration, applicants, arrival_dt, departure_dt })
                this.setState({ documents_pool: res.data.dataobj.application.documents_pool })
                this.setState({ applicantsArr: res.data.dataobj.applicants })
                // console.log(">>>>>>>>>> " + JSON.stringify(this.state.applicantsArr))
                if (this.state.getDocData) {
                    this.setState({ "activeItem": this.state.applicantsArr[0]._id })
                    this.getApplicantDocData(this.state.applicantsArr[0]._id)

                }
                // console.log(res.data.dataobj.application.documents_pool)


            })
            .catch(err => {
                console.log(err);
            })
    }



    removelinkedApplicantsDocument(card) {
        // console.log("card icon clicked", card);

        axios.post("/visa/removelinkedApplicantsDocument", {
            "applicant_id": localStorage.getItem("applicant_id"),
            "doc_id": card.doc_id

        }).then((res) => {
            // console.log("card icon",res);

            if (res.data.data === "success") {
                // console.log("card icon message", res.data.msg);
                this.getApplicantDocData(localStorage.getItem("applicant_id"))
                this.setState({ showRemoveModal: !this.state.showRemoveModal })


            }
        }).catch((err) => {
            console.log(err);
        })
    }

    api_deleteDocument(card) {
        axios
            .post('/visa/deleteDocumentFromPool', {
                "application_id": localStorage.getItem("application_id"),
                "user_id": localStorage.getItem('user_id'),
                file_name: card.file_name
            },
                {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                })
            .then((res) => {
                if (res.data.data === "error") {


                } else {
                    this.setState({
                        isDocDeleted: true,
                        deleteDocMessage: res.data.msg
                    })
                    setTimeout(() => {
                        this.setState({ isDocDeleted: false })
                    }, 4000)
                    this.api_getApplicantsDetails()
                }

            })
            .catch((err) => {
                console.log(err)
            })
    }
    handleDeleteIconClick = card => {
        // console.log("delete clicked")
        // this.setState({
        //     showDeleteModall: !this.state.showDeleteModall,
        //     cardToDelete: card


        // })


        this.setState({
            showDeleteModall: !this.state.showDeleteModall,
            cardToDelete: card
        })



    }



    // handleminimumModal = () => {
    //     this.setState({ showMinimumModal: !this.state.showMinimumModal })

    // }

    validPassportModal() {
        this.setState({ expiryModal: !this.state.expiryModal })

    }

    deleteToggle = () => {
        this.setState({ showDeleteModall: !this.state.showDeleteModall })
    }

    removeToggle = () => {
        this.setState({ showRemoveModal: !this.state.showRemoveModal })

    }

    removeDocumentCard(card) {
        this.setState({ showRemoveModal: !this.state.showRemoveModal, removeCard: card })
    }


    handleModalDeleteClick = () => {
        this.setState({ showDeleteModall: !this.state.showDeleteModall })
        var card = this.state.cardToDelete
        this.api_deleteDocument(card)
    }

    handleZoomIconClick = card => {
        // console.log("zoom icon clicked...")
        this.setState({ showImageZoomModal: !this.state.showImageZoomModal, cardToZoomImg: card })
    }
    zoomImgToggle = () => {
        this.setState({ showImageZoomModal: !this.state.showImageZoomModal })
    }

    handleEditconClick = card => {
        // console.log("CARD <==> ", card);
        // console.log("zoom icon clicked...")
        this.setState({ docIdentifier: card.doc_identifier, docFileName: card.file_name })
        // console.log("id", card.doc_identifier);
        this.setState({ showImageEditModal: !this.state.showImageEditModal, cardToZoomImg: card, croppedImageUrl: "" })
    }

    editImgToggle = () => {
        this.setState({ showImageEditModal: !this.state.showImageEditModal })
        this.setState({ saveLoader: false })
    }




    saveCroppedImage = (crop) => {
        // console.log("CROPPPPPPP", crop);
        // this.setState({croppedImageUrl : crop})

        this.setState({ saveLoader: true })
        const data = new FormData();
        data.append('document', crop, this.state.docFileName)
        data.append("doc_identifier", this.state.docIdentifier)
        data.append("application_id", localStorage.getItem("application_id"))

        axios.post("/process-documents/updateExtractedDocument", data)
            .then(res => {
                // console.log(res);
                if (res.data.data === "success") {
                    this.setState({ getDocData: false })
                    this.api_getApplicantsDetails()
                    // console.log(res.data.msg);
                    // window.location.reload()
                    setTimeout(() => {
                        this.setState({ showImageEditModal: !this.state.showImageEditModal })
                        this.setState({ saveLoader: false })

                        // window.location.reload()
                    }, 1000)
                } else {
                    console.log("err");
                }
            })
    }







    handleUploadApplicantDoc(event, applicantId, docType, docName) {
        //console.log(applicantId)
        console.log("upload applicant document...")
        // console.log(event)
        // console.log(event.name,docType,docName)
        // console.log(localStorage.getItem("application_id"));

        const data = new FormData();
        data.append('applicant_id', applicantId)
        data.append('application_id', localStorage.getItem("application_id"))
        data.append('doc_type', docType)
        data.append('doc_name', docName)
        data.append('document', event, event.name)

        axios
            .post("/utils/uploadFile", data)
            .then(res => {
                // console.log(res);
                this.getApplicantDocData(applicantId)
            })
            .catch(err => {
                console.log(err)
            })
    }

    deleteLastApplicant() {
        // console.log("less than one", this.state.applicantsArr.length);

        if (this.state.applicantsArr.length < 2) {
            this.setState({
                showMinimumModal: true
            })
        }
    }

    handleDeleteApplicantTab(applicantId, appTab) {
        console.log("applicant_id ===" + applicantId);
        console.log("activeItem ===" + this.state.activeItem)


        // console.log("less than one" , this.state.applicantsArr.length);
        // if (this.state.applicantsArr.length < 2) {
        //     this.setState({
        //         showMinimumModal: !this.state.showMinimumModal
        //     })

        // } else{

        axios
            .post('/visa/deleteApplicantFromApplication',
                {
                    "application_id": localStorage.getItem('application_id'),
                    "user_id": localStorage.getItem('user_id'),
                    "applicant_id": this.state.activeItem
                },
                {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                })
            .then(res => {
                // console.log(res);
                //this.setState({dataObj: res.data.dataobj})
                axios
                    .post('/visa/getApplicationApplicantsDetails', {
                        "application_id": localStorage.getItem('application_id')
                    },
                        {
                            headers: {
                                'Content-Type': 'application/json'
                            }
                        })
                    .then(res => {
                        // console.log(res);

                        //this.setState({documents_pool: res.data.dataobj.application.documents_pool})
                        this.setState({ applicantsArr: res.data.dataobj.applicants })
                        // console.log(">>>>>>>>>> " + JSON.stringify(this.state.applicantsArr))
                        //this.setState({"activeItem":this.state.dataObj._id})
                        // console.log("----- " + applicantId)
                        if (applicantId === this.state.activeItem) {
                            //console.log(appTab[1]._id);
                            this.getApplicantDocData(appTab[1]._id)
                            //console.log(res.data.dataobj.application.documents_pool)
                            this.setState({ activeItem: appTab[1]._id })
                        } else {
                            this.getApplicantDocData(applicantId)
                            //console.log(res.data.dataobj.application.documents_pool)
                            this.setState({ activeItem: applicantId })
                        }


                    })
                    .catch(err => {
                        console.log(err);
                    })



            })
            .catch(err => {
                console.log(err);
            })



        // }
    }

    handleAddApplicant() {
        this.setState({
            showMinimumModal: false
        })

        this.setState({ noApplicantFound: false })

        // console.log(this.state.activeItem)
        console.log("add applicant...")
        axios
            .post('/visa/addApplicant', {
                "application_id": localStorage.getItem('application_id'),
                "user_id": localStorage.getItem('user_id')
            },
                {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                })
            .then(res => {
                // console.log(res.data.dataobj);
                this.setState({ dataObj: res.data.dataobj })

                axios
                    .post('/visa/getApplicationApplicantsDetails', {
                        "application_id": localStorage.getItem('application_id')
                    },
                        {
                            headers: {
                                'Content-Type': 'application/json'
                            }
                        })
                    .then(res => {
                        // console.log(res);
                        //this.setState({documents_pool: res.data.dataobj.application.documents_pool})
                        this.setState({ applicantsArr: res.data.dataobj.applicants })
                        // console.log(">>>>>>>>>> " + JSON.stringify(this.state.applicantsArr))
                        // console.log("----- " + this.state.dataObj._id)
                        this.setState({ activeItem: this.state.dataObj._id })
                        this.getApplicantDocData(this.state.dataObj._id)
                        //console.log(res.data.dataobj.application.documents_pool)
                    })
                    .catch(err => {
                        console.log(err);
                    })
            })
            .catch(err => {
                console.log(err);
            })
    }
    handleAddDocument() {
        axios
            .post('/visa/addOtherDocumentForApplicant',
                {
                    "applicant_id": localStorage.getItem("applicant_id")
                },
                {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                })
            .then(res => {
                // console.log(res);
                //this.setState({dataObj: res.data.dataobj})
                this.getApplicantDocData(localStorage.getItem("applicant_id"))
            })
            .catch(err => {
                console.log(err);
            })
    }

    documentsPool = (card, index) => {
        // var cards = []
        // for(var i=0; i<8;i++){
        //     cards [i] = (
        //         <>
        //this.setState({doc_img: card.file_thumbnail})
        // console.log("document card", card)
        return (

            <MDBCol size="6" sm="12" md="2" lg="2">
                <Drag key={JSON.stringify(card)} dataItem={JSON.stringify(card)} dragImage={logo} dropEffect="link">

                    <MDBCard style={{ position: 'relative', width: '100%', height: '200px' }} className="card-input text-center mb-4">
                        <img className="img-fluid icon-actions " onClick={() => this.handleDeleteIconClick(card)} style={{ position: 'absolute', bottom: 0, left: 0, backgroundColor: 'white' }} src={delete_icon} />
                        <img className="img-fluid icon-actions" onClick={() => this.handleEditconClick(card)} style={{ position: 'absolute', bottom: 0, left: 25, backgroundColor: 'white' }} src={edit_icon} />
                        <img className="img-fluid icon-actions" style={{ position: 'absolute', bottom: 0, left: 50, backgroundColor: 'white' }} src={move_icon} />
                        <img className="img-fluid icon-actions" onClick={() => this.handleZoomIconClick(card)} style={{ position: 'absolute', bottom: 0, left: 74, backgroundColor: 'white' }} src={zoom_icon} />

                        <img className="img-fluid p-2" src={card.file} onError={(e) => { e.target.onerror = null; e.target.src = card.file }} style={{ width: '100%', height: '200px', objectFit: "contain" }}></img>

                    </MDBCard>
                    {/* <div className="modal fade" id="imgModal" tabindex="-1" role="dialog" aria-labelledby="imgModalLabel" aria-hidden="true" isOpen={this.state.modal} toggle={() => this.toggleModal()}>
                    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                
                                <h6 className="modal-title" id="imgModalLabel">{card.file_name}</h6>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body">
                                <img className="img-fluid" width="100%"  src={card.file}></img>
                            </div>
                        </div>
                    </div>
                </div> */}
                </Drag>
            </MDBCol>

        );

        //         </>
        //     )
        // }
        // return cards
    }

    getApplicantDocData(app_id) {
        // console.log("applicant id ------ getApplicantDocData()" , app_id)
        // console.log("application id ----- " + localStorage.getItem('application_id'))



        axios
            .get('/visa/getApplicantDocumentData', {
                params: {
                    application_id: localStorage.getItem('application_id'),
                    applicant_id: app_id
                }
            })
            .then((resp) => {
                // console.log("####", resp)
                // console.log(resp.data.dataobj.applicant_doc.required_documents)
                var all_documents = resp.data.dataobj.applicant_doc.required_documents.concat(resp.data.dataobj.applicant_doc.additional)
                localStorage.setItem("applicant_id", app_id)
                this.setState({ appDocData: all_documents })
                this.state.appDocData.map((items) => {
                })
                this.setState({ imageLoader: false })
                //console.log(resp.data.dataobj.applicant_doc.required_documents)
                // console.log(this.state.applicant_id)
                // this.state.appDocData.map((this.applicantDocData))
                // this.state.appDocData.map((items) => {
                //     console.log(items)
                //     items.doc_snap.map((doc_snap) => {
                //         var fileListObj = {
                //             uid: items.doc_type,
                //             name: doc_snap.doc_name,
                //             status: doc_snap.status,
                //             url: doc_snap.doc_url
                //         }
                //         console.log(doc_snap)
                //         // if(doc_snap.status !== "pending"){
                //         this.state.fileList.push(fileListObj)
                //         this.setState({fileList: this.state.fileList})
                //         //}
                //     })
                // })
                // console.log(this.state.fileList)
            })
            .catch(err => {
                console.log(err);
            })
    }

    // itemDropped = (item) => {
    //     console.log(item)
    // } 
    check_if_doc_is_required = (card, doc_type, doc_name) => {
        
        var is_required = card.doc_snap[0].mandatory ? card.doc_snap[0].mandatory : false
        
        if (is_required) {
            return <div className="w-100 mt-2">{doc_name.replace(/_/g, ' ').toUpperCase()}<span style={{ color: "red" }}>{"*"}</span></div>
        } else {
            return <div className="w-100 mt-2">{doc_name.replace(/_/g, ' ').toUpperCase()}</div>
        }

    }
    applicantDocData = (card, index) => {


        // console.log(card)
        var doc_url, doc_name;
        for (var i = 0; i < card.doc_snap.length; i++) {
            doc_name = card.doc_snap[i].doc_name
            doc_url = card.doc_snap[i].doc_url
            // console.log(doc_name)
        }

        return (
            <>

                {/* <div className="drag-drop-container"> */}
                <MDBCol size="6" sm="12" md="2" lg="2">
                    <DropTarget applicant_id="" doc_type={card.doc_type} key_index={index} onItemDropped={this.itemDropped} dropEffect="link">
                        <MDBCard style={{ position: 'relative', width: '100%', height: '200px', marginTop: '20px' }} className="card-input text-center mb-4">

                            <FilePicker
                                maxSize={20}
                                extensions={['jpg', 'jpeg', 'png']}
                                onChange={FileObject => (this.handleUploadApplicantDoc(FileObject, this.state.activeItem, card.doc_type, doc_name))}
                            >

                                <img className="img-fluid p-2" src={doc_url} onError={(e) => { e.target.onerror = null; e.target.src = "https://s3.ap-southeast-1.amazonaws.com/visaero.assets/placeholder-passport_upload.png" }} style={{ width: '100%', height: '200px', objectFit: "contain" }}></img>



                            </FilePicker>
                            <img className="img-fluid icon-actions bg-white p-1 shadow " onClick={() => this.removeDocumentCard(card)} style={{ position: 'absolute', bottom: 0, left: 0, backgroundColor: 'white' }} src={delete_icon} />
                            {/* <div style={{ marginTop: 8 }}>{card.doc_snap[0].doc_name.replace(/_/g, ' ').toUpperCase()}</div> */}
                        </MDBCard>
                        {this.check_if_doc_is_required(card, card.doc_type, card.doc_snap[0].doc_name)}

                        {/* <div style={{ marginTop: 8 }}>{card.doc_snap[0].doc_name.replace(/_/g, ' ').toUpperCase()}</div> */}
                    </DropTarget>
                </MDBCol>
                {/* <div className="modal fade" id="infoModal" tabindex="-1" role="dialog" aria-labelledby="infoModalLabel" aria-hidden="true" isOpen={this.state.modal} toggle={() => this.toggleModal()}>
                    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" role="document">
                        <div className="modal-content">
                        <div className="modal-header">
                            
                            <h3 className="modal-title" id="infoModalLabel"><b>Required Documents</b></h3>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                        <p>  Are you sure, you want to delete the document?</p>
                        </div>
                        <div className="modal-footer">
                        <MDBBtn color="none" data-dismiss="modal" style={{color:'white',backgroundColor:'black', textTransform:'none',}} onClick={this.removelinkedApplicantsDocument(card)} >Remove</MDBBtn>
                            <MDBBtn color="none" data-dismiss="modal" style={{color:'white',backgroundColor:'black', textTransform:'none',}}>Close</MDBBtn>
                        </div>
                    </div>
                </div>
                </div> */}

                {/* </div> */}

            </>
        );


    }
    handleProceed = () => {
        this.api_getMissingDocsList()


    }
    api_getMissingDocsList() {
        var applicantJsonArray = []
        for (var index in this.state.applicantsArr) {
            var applicant = this.state.applicantsArr[index]
            var obj = {
                "applicant_id": applicant._id
            }
            applicantJsonArray.push(obj)

        }
        if (applicantJsonArray.length === 0) {
            // Swal.fire({ icon: 'error',
            //       text:  'Please add applicant' ,})
            this.setState({
                isError: true,
                errorMsg: 'Please add applicant'
            })
            setTimeout(() => {
                this.setState({ isError: false, errorMsg: "" })
            }, 2000)

            return
        }
        axios
            .post('/visa/getMissingDocumentsForApplication', {
                "application_id": localStorage.getItem('application_id'),
                "user_id": localStorage.getItem('user_id'),
                "applicants": applicantJsonArray
            },
                {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                })
            .then(res => {
                // console.log(res);

                if (res.data.data === "success") {
                    var missings = res.data.dataobj
                    if (missings.length > 0) {
                        var b = []
                        missings.map((missing) => {
                            var a = missing.replace("null", " ")
                            b.push(a)
                        })
                        // console.log("missing", b);
                        this.setState({ missingData: b })

                        this.missingFieldToggle()
                    } else {

                        axios
                            .post('/visa/getApplicationApplicantsDetails', {
                                "application_id": localStorage.getItem('application_id')
                            },
                                {
                                    headers: {
                                        'Content-Type': 'application/json'
                                    }
                                })
                            .then(res => {
                                console.log(res);
                                var expiryDate = ""
                                var applicantArray = res.data.dataobj.applicants
                                // res.data.dataobj.applicants.map((expiry)=>{

                                for (let index = 0; index < applicantArray.length; index++) {
                                    const element = applicantArray[index];
                                    // console.log(element);
                                    var expiredPassport = false
                                    expiryDate = element.visa_form.date_of_expiry
                                    // console.log(expiryDate);
                                    if (expiryDate == null) {
                                        expiryDate = ""
                                    }
                                    var b = (expiryDate).split("-")
                                    var c = b[2] + "-" + b[1] + "-" + b[0]
                                    if (new Date().getTime() > new Date(c).getTime()) {
                                        expiredPassport = true
                                        // console.log("hey")
                                        this.setState({ passportExpiredApplicant: element.applicant_first_name + " " + element.applicant_last_name })
                                        this.setState({ expiryModal: expiredPassport })
                                        this.setState({ expiry_date: expiredPassport })
                                    }
                                    // console.log(expiredPassport); 
                                    if (expiredPassport === true) {
                                        break;
                                    }

                                }

                                if (!expiredPassport) {
                                    this.setState({ isProceed: true })

                                }

                            })
                            .catch(err => {
                                console.log(err);
                            })


                    }
                }
            })
            .catch(err => {
                console.log(err);
            })
    }


    render() {
        if (this.state.toTrackApplication) {
            // console.log(this.state.toTrackApplication)
            return <Redirect to="/track-application" />
        }

        if (this.state.isProceed) {
            return <Redirect to="/payment-details" />
        }
        




        const { previewVisible, previewImage, fileList, previewTitle } = this.state;
        const uploadButton = (
            <div>
                {/* <PlusOutlined /> */}
                <div style={{ marginTop: 8 }}>
                    <img src={upload_icon} width={70} />
                </div>
            </div>
        );

        // console.log(">>>>>> " + this.state.activeItem)






        return (
            <>
                <div>
                    <h4><b>Apply New Visa</b></h4>
                </div>
                <BasicInfoCard applicantLength={this.state.applicantsArr} />


                {this.state.noApplicantFound &&
                    <>
                        <br />


                        <MDBAlert color="warning">
                            <strong>No passport document found !</strong> You can edit the passport document by tapping on the edit icon against it. You can also click on add applicant button and upload a new passport document.
                </MDBAlert>

                    </>
                }
                {/* <div className="mt-4">
                    <MDBCard>
                        <MDBCardBody>
                            <MDBCardTitle>Basic Information</MDBCardTitle>
                            <hr/>
                            <MDBRow>
                                <MDBCol size="12" lg="3">
                                    <MDBTable borderless>
                                        <tr>
                                            <th>Country of Residence: </th><td>{this.state.origin}</td>
                                        </tr>
                                    </MDBTable>
                                </MDBCol>
                                <MDBCol size="12" lg="3">
                                    <MDBTable borderless>
                                        <tr>
                                            <th>Travelling To: </th><td>{this.state.travelling_to_country}</td>
                                        </tr>
                                    </MDBTable>
                                </MDBCol>
                                <MDBCol size="12" lg="3">
                                    <MDBTable borderless>
                                        <tr>
                                            <th>Visa Type: </th><td>{this.state.visa_type} | {this.state.entry_type} Entry</td>
                                        </tr>
                                    </MDBTable>
                                </MDBCol>
                                <MDBCol size="12" lg="3">
                                    <MDBTable borderless>
                                        <tr>
                                            <th>Visa Duration: </th><td>{this.state.visa_duration} Days</td>
                                        </tr>
                                    </MDBTable>
                                </MDBCol>
                            </MDBRow>
                            <MDBRow>
                                <MDBCol size="12" lg="3">
                                    <MDBTable borderless>
                                        <tr>
                                            <th>Nationality: </th><td>{this.state.nationality}</td>
                                        </tr>
                                    </MDBTable>
                                </MDBCol>
                                <MDBCol size="12" lg="3">
                                    <MDBTable borderless>
                                        <tr>
                                            <th>Applicants: </th><td>{this.state.applicants}</td>
                                        </tr>
                                    </MDBTable>
                                </MDBCol>
                                <MDBCol size="12" lg="4">
                                    <MDBTable borderless>
                                        <tr>
                                            <th>Travelling Dates: </th><td>{this.state.arrival_dt} To {this.state.departure_dt}</td>
                                        </tr>
                                    </MDBTable>
                                </MDBCol>
                            </MDBRow>
                        </MDBCardBody>
                    </MDBCard>
                </div>  
                <div className="mt-4">
                    <MDBCard >
                        <MDBCardBody >
                            <div className='d-flex align-items-center justify-content-between'>
                                <MDBCardTitle className='mb-0'>Uploaded Documents</MDBCardTitle>
                            </div>
                            <hr />
                            <div style={{ height: '17rem', overflowX: 'scroll' }}>
                                <MDBRow>

                                    {this.state.documents_pool.map(this.documentsPool)}
                                </MDBRow>
                            </div>
                        </MDBCardBody>
                    </MDBCard>
                </div>
                <MDBRow>
                    <MDBCol size="12" xs="6" sm="6" md="8" lg="6"></MDBCol>
                    <MDBCol size="12" xs="6" sm="6" md="8" lg="6" className="text-right">
                        <MDBBtn id="reviewBtn" style={{ color: this.state.brand_color, fontSize: 'calc(8px + .5rem)', textTransform: 'none' }} color="none" onClick={this.handleAddApplicant}> + Add Applicant</MDBBtn>
                    </MDBCol>
                </MDBRow>
            */}
            <div className="mt-4">
                    <MDBCard >
                        <MDBCardBody >
                            <div className='d-flex align-items-center justify-content-between'>
                                <MDBCardTitle className='mb-0'>Additional Documents</MDBCardTitle>
                            </div>
                            </MDBCardBody>
                            </MDBCard>
                            </div>
                <div className="mt-4">
                    {/* {console.log("123", this.state.applicantsArr.length)} */}
                     
                    <MDBCard style={{ minHeight: '15rem', marginBottom: '10%' }}>

                        <MDBNav className="nav-tabs">
                            {
                                this.state.applicantsArr.map((applicant_tab, index) =>
                                    <>
                                        {/* <p>{applicant_tab._id}</p> */}
                                        {/* {applicant_tab.file_type === "passport-front" && */}
                                        <MDBNavItem >
                                            <MDBNavLink link to="#" active={this.state.activeItem === applicant_tab._id} onClick={this.toggle(applicant_tab._id)} key={index} role="tab">
                                                {applicant_tab.applicant_first_name} {applicant_tab.applicant_last_name}&nbsp;
                                        <img className="img-fluid icon-actions" style={{ position: 'absolute' }} onClick={this.deleteLastApplicant} src={delete_icon} data-toggle="modal" data-target="#deleteApplicantModal" />&nbsp; &nbsp;
                                        {/* <img className="img-fluid icon-actions" style={{position:'absolute'}} src={delete_icon} onClick={this.handleDeleteApplicantTab(applicant_tab._id)}/>&nbsp; &nbsp; */}
                                                {/* {this.setState({imageLoader : false})} */}
                                            </MDBNavLink>
                                        </MDBNavItem>
                                        {/* }                                         */}

                                        {this.state.applicantsArr.length > 1 &&

                                            <div className="modal fade" id="deleteApplicantModal" tabindex="-1" role="dialog" aria-labelledby="deleteApplicantModalLabel" aria-hidden="true" isOpen={this.state.modal} toggle={() => this.toggleModal()}>
                                                <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" role="document">
                                                    <div className="modal-content">
                                                        <div className="modal-header">

                                                            <h6 className="modal-title" id="deleteApplicantModalLabel"><b>Delete Applicant</b></h6>
                                                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                                                <span aria-hidden="true">&times;</span>
                                                            </button>
                                                        </div>
                                                        <div class="modal-body">
                                                            <p>Are you sure, you want to delete the applicant ?</p>
                                                        </div>
                                                        <div className="modal-footer">
                                                            <MDBBtn color="none" data-dismiss="modal" style={{ color: 'white', backgroundColor: 'black', textTransform: 'none', }}>Close</MDBBtn>
                                                            <MDBBtn color="none" data-dismiss="modal" onClick={() => { this.handleDeleteApplicantTab(applicant_tab._id, this.state.applicantsArr) }} style={{ color: 'white', backgroundColor: this.state.brand_color, textTransform: 'none', }}>Delete</MDBBtn>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        }
                                    </>
                                )
                            }

                        </MDBNav>
                        {/* {this.state.applicantsArr.map((applicant_doc, index) => */}
                        <>
                            <MDBTabContent activeItem={this.state.activeItem}  >
                                <MDBTabPane tabId={this.state.activeItem} role="tabpanel"     >
                                    {/* <MDBContainer fluid> */}
                                    <MDBRow className="p-4">
                                        {/* <MDBCol size="6" sm="12" md="2" lg="2"> */}
                                        {/* <Upload 
                                                // action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
                                                listType="picture-card"
                                                fileList={fileList}
                                                onPreview={this.handlePreview}
                                                onChange={this.handleChange}
                                                //showPreviewIcon={false}                                                  
                                                >
                                            
                                                {fileList.length >= 8 ? null : uploadButton}
                                                
                                            </Upload>
                                            <Modal
                                                visible={previewVisible}
                                                title={previewTitle}
                                                footer={null}
                                                onCancel={this.handleCancel}
                                                >
                                                <img alt="example" style={{ width: '100%' }} src={previewImage} />
                                            </Modal> */}
                                        {/* {console.log(this.state.appDocData)} */}
                                        {
                                            this.state.appDocData.map((this.applicantDocData))
                                        }
                                        {this.state.imageLoader &&

                                            <img src={image_loader} className="image_load" />
                                        }
                                    </MDBRow>
                                    {/* </MDBContainer> */}
                                </MDBTabPane>
                            </MDBTabContent>
                        </>
                        {/* {!this.state.noApplicantFound &&
                            <div className="text-right" style={{ right: 0 }}>
                                <MDBBtn className="text-right" id="reviewBtn" style={{ color: this.state.brand_color, fontSize: 'calc(8px + .5rem)', textTransform: 'none' }} color="none" onClick={this.handleAddDocument}> + Add Document</MDBBtn>
                            </div>
                        } */}
                         
                    </MDBCard>
                </div>
                <div className="modal fade" id="draftModal" tabindex="-1" role="dialog" aria-labelledby="draftModalLabel" aria-hidden="true" isOpen={this.state.modal} toggle={() => this.toggleModal()}>
                    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" role="document">
                        <div className="modal-content">
                            <div className="modal-header">

                                <h6 className="modal-title" id="draftModalLabel"><b>Save as Draft</b></h6>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body">
                                <p>We will save your information and documents. You can resume anytime from 'Track Application'.</p>
                            </div>
                            <div className="modal-footer">
                                <MDBBtn color="none" data-dismiss="modal" style={{ color: 'white', backgroundColor: 'black', textTransform: 'none', }}>Close</MDBBtn>
                                <MDBBtn color="none" data-dismiss="modal" onClick={() => { this.setState({ toTrackApplication: true }) }} style={{ color: 'white', backgroundColor: this.state.brand_color, textTransform: 'none', }}>Save</MDBBtn>
                                {/* </RouterLink> */}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal fade" id="docInfoModal" tabindex="-1" role="dialog" aria-labelledby="docInfoModalLabel" aria-hidden="true" isOpen={this.state.modal} toggle={() => this.toggleModal()}>
                    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" role="document">
                        <div className="modal-content">
                            <div className="modal-header">

                                <h6 className="modal-title" id="docInfoModalLabel"><b>Why a document is required?</b></h6>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body">
                                <p> some message</p>
                            </div>
                            <div className="modal-footer">
                                <MDBBtn color="none" data-dismiss="modal" style={{ color: 'white', backgroundColor: this.state.brand_color, textTransform: 'none', }}>Ok</MDBBtn>
                            </div>
                        </div>
                    </div>
                </div>
                {this.state.showDeleteModall &&
                    <MDBModal centered isOpen={this.state.showDeleteModall} toggle={this.deleteToggle}>
                        <MDBModalHeader toggle={this.deleteToggle}>Delete Document</MDBModalHeader>
                        <MDBModalBody>
                            Are you sure, you want to delete the document?
                  </MDBModalBody>
                        <MDBModalFooter>
                            <MDBBtn color='white' style={{ textTransform: 'none' }} onClick={this.deleteToggle} >Cancel</MDBBtn>
                            <MDBBtn color="dark" style={{ textTransform: 'none' }} onClick={this.handleModalDeleteClick}>Delete</MDBBtn>

                        </MDBModalFooter>
                    </MDBModal>

                }

                {this.state.showRemoveModal &&
                    <MDBModal centered isOpen={this.state.showRemoveModal} toggle={this.removeToggle}>
                        <MDBModalHeader toggle={this.removeToggle}>Delete Document</MDBModalHeader>
                        <MDBModalBody>
                            Are you sure, you want to delete the document?
                  </MDBModalBody>
                        <MDBModalFooter>
                            <MDBBtn color='white' style={{ textTransform: 'none' }} onClick={this.removeToggle} >Cancel</MDBBtn>
                            <MDBBtn color="dark" style={{ textTransform: 'none' }} onClick={() => this.removelinkedApplicantsDocument(this.state.removeCard)}>Delete</MDBBtn>

                        </MDBModalFooter>
                    </MDBModal>

                }



                {this.state.showImageZoomModal &&
                    <MDBModal centered isOpen={this.state.showImageZoomModal} toggle={this.zoomImgToggle}>
                        <MDBModalBody>
                            <img className="img-fluid" width="100%" src={this.state.cardToZoomImg.file}></img>
                        </MDBModalBody>
                        <MDBModalFooter>
                            <MDBBtn color='white' style={{ textTransform: 'none' }} onClick={this.zoomImgToggle} >Cancel</MDBBtn>
                        </MDBModalFooter>
                    </MDBModal>
                }

                {/* 
                <MDBModal centered isOpen={this.state.showMinimumModal} toggle={this.deleteToggleModal}>
                    <MDBModalHeader toggle={this.deleteToggleModal}>Delete Document</MDBModalHeader>
                    <MDBModalBody>
                        Number of applicant must be one.
                  </MDBModalBody>
                    <MDBModalFooter>
                        <MDBBtn color='white' style={{ textTransform: 'none' }} onClick={this.deleteToggleModal} >Cancel</MDBBtn>
                       

                    </MDBModalFooter>
                </MDBModal> */}


                {this.state.showImageEditModal &&
                    <MDBModal centered isOpen={this.state.showImageEditModal} toggle={this.editImgToggle}>
                        <MDBModalHeader onClick={this.editImgToggle} className="edit-img" > <MDBBtn className="float-right btn-defaultfloat-right btn-light shadow-none bg-white" > <span style={{ justifyContent: "end" }}>X</span></MDBBtn> </MDBModalHeader>
                        <MDBModalBody style={{ height: "max-content" }}>

                            <ImageEditorRc
                                ref='cropper'
                                // crossOrigin='true' // boolean, set it to true if your image is cors protected or it is hosted on cloud like aws s3 image server
                                crossOrigin={true}
                                src={this.state.cardToZoomImg.file}
                                // src="https://picsum.photos/seed/picsum/200/300"
                                style={{ height: 400, width: "100%", alignItem: "center", justifyContent: "center" }}
                                // aspectRatio={16 / 9}
                                className="image_edit"
                                guides={true}
                                rotatable={true}
                                // aspectRatio={16 / 9}
                                imageName='image name with extension to download'
                                saveImage={this.saveCroppedImage} // it has to catch the returned data and do it whatever you want
                                responseType='blob'
                                guides={false}
                            // responseType = "image/.png"

                            />

                            {this.state.saveLoader &&
                                <img src={image_loader} className="position-absolute m-auto left-0 right-0 top-0 bottom-0" />
                            }
                            <img src={this.state.croppedImageUrl} style={{ marginTop: "15%", width: "200px" }} />


                        </MDBModalBody>
                        {/* <MDBModalFooter>
                            <MDBBtn color='white' style={{ textTransform: 'none' }} onClick={this.editImgToggle} >Cancel</MDBBtn>
                        </MDBModalFooter> */}
                    </MDBModal>
                }


                {this.state.expiry_date &&
                    <MDBModal centered isOpen={this.state.expiryModal} toggle={this.validPassportModal}>
                        <MDBModalHeader toggle={this.validPassportModal}>Passport Validity</MDBModalHeader>
                        <MDBModalBody>
                            <>
                                <h6>{this.state.passportExpiredApplicant} - Your Passport has expired.</h6>
                            </>
                        </MDBModalBody>
                        <MDBModalFooter>
                            <MDBBtn color="dark" style={{ textTransform: 'none' }} onClick={this.validPassportModal}>Ok</MDBBtn>
                        </MDBModalFooter>
                    </MDBModal>

                }


                <MDBModal centered isOpen={this.state.showMissingFieldModal} toggle={this.missingFieldToggle}>
                    <MDBModalHeader toggle={this.missingFieldToggle}>Missing Documents</MDBModalHeader>
                    <MDBModalBody>
                        <>
                            {/* <h8>{this.state.missingData}</h8> */}
                            {this.state.missingData.map((fields) =>
                                <li>
                                    {fields}
                                </li>
                            )}
                        </>

                    </MDBModalBody>
                    <MDBModalFooter>
                        {/* <MDBBtn color='white' style = {{textTransform:'none'}} onClick={this.missingFieldToggle}>Cancel</MDBBtn> */}
                        <MDBBtn color="dark" style={{ textTransform: 'none' }} onClick={this.missingFieldToggle}>Ok</MDBBtn>
                    </MDBModalFooter>
                </MDBModal>

                <MDBRow id="footerRow" style={{ width: "100%", marginTop: "5%" }}>
                    <MDBFooter style={{ background: "#fff", position: "fixed", bottom: "0px", width: "100%", zIndex: "1", left: "0", right: "0", borderTop: "1px solid #ccc", boxShadow: "0px 0 10px rgba(0, 0, 0, 0.2)" }} color="white" className="pb-1 pt-1 text-right">

                        {/* <MDBContainer> */}
                        <MDBRow >
                            {/* <MDBCol size="12" xs="6" sm="6" md="8" lg="6"> */}
                            <MDBCol size="12" sm="6" md="6" lg="6" >
                                {
                                    this.state.isDocDeleted &&
                                    <MDBAlert color='success'>{this.state.deleteDocMessage}</MDBAlert>
                                }
                                {
                                    this.state.showMinimumModal &&
                                    <MDBAlert color='danger'>Number of Applicant must be one.</MDBAlert>
                                }
                                {
                                    this.state.isError &&
                                    <MDBAlert color='danger'>{this.state.errorMsg}</MDBAlert>
                                }
                            </MDBCol>

                            <MDBCol size="12" sm="6" md="6" lg="6" style={{ textAlign: 'right' }}>
                                {/* <MDBCol size="6" sm="3" md="3" lg="3" >  */}
                                <MDBBtn id="saveBtn" data-toggle="modal" data-target="#draftModal" style={{ color: 'white', backgroundColor: 'black', fontSize: 'calc(8px + .5rem)', textTransform: 'none' }} color="none">Save as Draft</MDBBtn>
                                <MDBBtn id="reviewBtn" style={{ color: 'white', backgroundColor: this.state.brand_color, fontSize: 'calc(8px + .5rem)', textTransform: 'none' }} color="none" onClick={this.handleProceed}>Proceed</MDBBtn>
                                {/* </MDBCol> */}
                            </MDBCol>
                            {/* </MDBCol> */}
                        </MDBRow>
                        {/* </MDBContainer> */}
                    </MDBFooter>
                </MDBRow>
            </>
        )
    }
}

export default AdditionalOrganizeApplication;
